import { useState, useRef } from 'react';
import emailjs from '@emailjs/browser';

// ─── EmailJS config ───────────────────────────────────────────
// 1. Go to https://www.emailjs.com  →  sign up free
// 2. Add Email Service  →  connect Gmail  →  copy Service ID
// 3. Create Email Template with variables: {{from_name}}, {{from_email}}, {{subject}}, {{message}}
// 4. Copy Template ID  +  Public Key  →  paste below
const EMAILJS_SERVICE_ID  = 'service_zkdm16p';   // e.g. service_xxxxxxx
const EMAILJS_TEMPLATE_ID = 'template_12jmcxs';  // e.g. template_xxxxxxx
const EMAILJS_PUBLIC_KEY  = 'ExGucAlIfn4mOLIYW';   // e.g. xxxxxxxxxxxxxxxxxxx

function WAIcon({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
    </svg>
  );
}

const CONTACT_CARDS = [
  { icon: '📧', label: 'Email',    value: 'akroshrm003@gmail.com', href: 'mailto:akroshrm003@gmail.com', color: '#FF9900', borderColor: 'border-l-aws' },
  { icon: null,  label: 'WhatsApp',value: '+91 8310691450',        wa: true,                             color: '#25D366', borderColor: 'border-l-[#25D366]' },
  { icon: '📱', label: 'Phone',    value: '+91 8310691450',        href: 'tel:+918310691450',            color: '#00D8FF', borderColor: 'border-l-cyan' },
  { icon: '📍', label: 'Location', value: 'Gulbarga, Karnataka, India',                                  color: '#94A3B8', borderColor: 'border-l-tx2' },
];

const LEARNING_PILLS = [
  { label: 'Python 🐍',       color: 'text-yel',  bg: 'bg-yel/10',  border: 'border-yel/25' },
  { label: 'AI / ML 🤖',     color: 'text-pur',  bg: 'bg-pur/10',  border: 'border-pur/25' },
  { label: 'React Native 📱', color: 'text-cyan', bg: 'bg-cyan/10', border: 'border-cyan/25' },
  { label: 'Serverless',      color: 'text-aws',  bg: 'bg-aws/10',  border: 'border-aws/25' },
];

export default function Contact() {
  const formRef = useRef(null);
  const [form, setForm]     = useState({ name: '', email: '', subject: '', message: '' });
  const [status, setStatus] = useState('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const set = (key) => (e) => setForm(p => ({ ...p, [key]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.email.trim() || !form.message.trim()) {
      setErrorMsg('Please fill in name, email, and message.');
      return;
    }
    setErrorMsg('');
    setStatus('sending');

    try {
      // Try EmailJS first (requires setup — see comments at top)
      if (EMAILJS_SERVICE_ID !== 'YOUR_SERVICE_ID') {
        await emailjs.sendForm(
          EMAILJS_SERVICE_ID,
          EMAILJS_TEMPLATE_ID,
          formRef.current,
          EMAILJS_PUBLIC_KEY
        );
        setStatus('success');
        setForm({ name: '', email: '', subject: '', message: '' });
      } else {
        // Fallback: open native mail client with all fields pre-filled
        const subject = encodeURIComponent(form.subject || `Portfolio — ${form.name}`);
        const body    = encodeURIComponent(
          `Name: ${form.name}\nEmail: ${form.email}\n\n${form.message}`
        );
        window.open(`mailto:akroshrm003@gmail.com?subject=${subject}&body=${body}`, '_blank');
        setStatus('success');
        setForm({ name: '', email: '', subject: '', message: '' });
      }
    } catch (err) {
      console.error('Email error:', err);
      setStatus('error');
      setErrorMsg('Failed to send. Trying mail client…');
      // Always fallback to mailto on error
      setTimeout(() => {
        const subject = encodeURIComponent(form.subject || `Portfolio — ${form.name}`);
        const body    = encodeURIComponent(
          `Name: ${form.name}\nEmail: ${form.email}\n\n${form.message}`
        );
        window.open(`mailto:akroshrm003@gmail.com?subject=${subject}&body=${body}`, '_blank');
        setStatus('idle');
        setErrorMsg('');
      }, 1200);
    }
  };

  const openWA = () =>
    window.open(
      'https://wa.me/918310691450?text=Hi%20Akrosh!%20I%20saw%20your%20portfolio%20and%20would%20like%20to%20connect.',
      '_blank'
    );

  return (
    <section
      id="contact"
      className="relative z-10 py-24 px-5 sm:px-8 lg:px-10"
      style={{ background: 'linear-gradient(180deg,#0d1220 0%,#080c14 100%)' }}
    >
      <div className="max-w-5xl mx-auto">

    
        <div className="mb-12">
          <span className="section-tag bg-grn/10 border border-grn/25 text-grn">
            {`// CONTACT`}
          </span>
          <h2 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight mb-3">
            Let's{' '}
            <span className="text-grn">build together</span>
          </h2>
          <p className="text-tx2 text-sm max-w-md">
            Open to freelance projects, full-time roles, and interesting collaborations.
          </p>
        </div>

        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-7">

         
          <div className="flex flex-col gap-3">

            {CONTACT_CARDS.map((card, i) => {
              const inner = (
                <div
                  key={i}
                  onClick={card.wa ? openWA : undefined}
                  className={`flex items-center gap-3.5 px-4 py-3.5 bg-surf border border-bord border-l-[3px] rounded-xl
                              transition-all duration-200 group
                              ${(card.href || card.wa) ? 'cursor-pointer hover:bg-surf2 hover:translate-x-1' : 'cursor-default'}`}
                  style={{ borderLeftColor: card.color }}
                >
                  <span className="text-xl flex-shrink-0">
                    {card.wa ? <WAIcon size={20} /> : card.icon}
                  </span>
                  <div>
                    <div className="font-mono text-[9px] text-tx3 uppercase tracking-[1.5px]">
                      {card.label}
                    </div>
                    <div className="text-sm font-semibold mt-0.5" style={{ color: card.color }}>
                      {card.value}
                    </div>
                  </div>
                </div>
              );
              return card.href
                ? <a key={i} href={card.href} className="no-underline">{inner}</a>
                : <div key={i}>{inner}</div>;
            })}

            <div className="bg-surf border border-bord rounded-xl p-4">
              <div className="font-mono text-[9px] text-tx3 uppercase tracking-[1.5px] mb-2.5">
                Currently Learning
              </div>
              <div className="flex flex-wrap gap-2">
                {LEARNING_PILLS.map(p => (
                  <span
                    key={p.label}
                    className={`font-mono text-[10px] font-medium rounded-md px-2.5 py-1 border
                                ${p.color} ${p.bg} ${p.border}`}
                  >
                    {p.label}
                  </span>
                ))}
              </div>
            </div>

            
            <button
              onClick={openWA}
              className="btn-wa w-full justify-center py-3.5 rounded-xl text-sm font-bold"
            >
              <WAIcon size={18} />
              Chat on WhatsApp — +91 8310691450
            </button>
          </div>

          <form
            ref={formRef}
            onSubmit={handleSubmit}
            className="bg-surf border border-bord rounded-2xl p-6 flex flex-col gap-4"
          >
            <div className="font-mono text-xs flex items-center gap-2 mb-1">
              <span className="text-aws">POST</span>
              <span className="text-tx3">/api/contact</span>
              {EMAILJS_SERVICE_ID !== 'YOUR_SERVICE_ID' && (
                <span className="ml-auto text-[10px] text-grn bg-grn/10 border border-grn/25 rounded-full px-2 py-0.5">
                  EmailJS ✓
                </span>
              )}
            </div>

            <div>
              <label className="font-mono text-[9px] text-tx3 block mb-1.5">"name" *</label>
              <input
                name="from_name"
                className="input-field"
                value={form.name}
                onChange={set('name')}
                placeholder="Your name"
                required
              />
            </div>

            <div>
              <label className="font-mono text-[9px] text-tx3 block mb-1.5">"email" *</label>
              <input
                name="from_email"
                type="email"
                className="input-field"
                value={form.email}
                onChange={set('email')}
                placeholder="you@example.com"
                required
              />
            </div>

            <div>
              <label className="font-mono text-[9px] text-tx3 block mb-1.5">"subject"</label>
              <input
                name="subject"
                className="input-field"
                value={form.subject}
                onChange={set('subject')}
                placeholder="Freelance project / job opportunity"
              />
            </div>

            <div>
              <label className="font-mono text-[9px] text-tx3 block mb-1.5">"message" *</label>
              <textarea
                name="message"
                className="input-field resize-y min-h-[90px]"
                value={form.message}
                onChange={set('message')}
                placeholder="Tell me about your project…"
                required
              />
            </div>

            {errorMsg && (
              <p className="text-red-400 text-xs font-mono">{errorMsg}</p>
            )}

            <button
              type="submit"
              disabled={status === 'sending' || status === 'success'}
              className={`w-full py-3.5 rounded-xl font-bold text-sm transition-all duration-200 border-none cursor-pointer
                         ${status === 'success'
                           ? 'bg-grn/15 text-grn border border-grn/30 cursor-default'
                           : status === 'error'
                           ? 'bg-red-500/15 text-red-400 border border-red-400/30'
                           : 'bg-gradient-to-r from-aws to-aws2 text-black hover:opacity-90'
                         }`}
            >
              {status === 'idle'    && '→ send_message()'}
              {status === 'sending' && '⏳ Sending…'}
              {status === 'success' && '✅ Message sent successfully!'}
              {status === 'error'   && '⚠️ Opening mail client…'}
            </button>

            {status === 'success' && (
              <button
                type="button"
                onClick={() => setStatus('idle')}
                className="text-tx3 text-xs font-mono underline cursor-pointer bg-transparent border-none text-center"
              >
                Send another message
              </button>
            )}
          </form>
        </div>
      </div>
    </section>
  );
}
